import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { uuid } from "uuidv4";

import { store } from "../../../../components/VerticalLayout/store";
import { store as logoStore, setIsLoading, setKey } from "../store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { showSuccessToast } from "@components/Common/SuccessToast";
import ErrorToast from "@components/Common/ErrorTost";
import { useFetchGlobal } from "../../../../api/hooks";
import { ArchivedSaleSupport } from "./helper";

type ConfirmationDeleteMessageType = {
    setIsModalConfirmationOpened: Function;
    isModalConfirmationOpened: boolean;
    setDataIsUpdated: Function;
    selectedRows: any;
};

export function ConfirmationActiveSaleSupport({
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    setDataIsUpdated,
    selectedRows,
}: ConfirmationDeleteMessageType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { shopsSaleSupportData } = useSnapshot(logoStore);
    const uuidUser = localStorage.getItem("uuidUser");

    async function activeSaleSupport(isValidation: boolean) {
        setIsLoading(true);
        toast.dismiss();
        let localData: any[] = [];

        Object.values(selectedRows).forEach(async (element: any) => {
            const id = element.Id;
            let shopsArchived = ArchivedSaleSupport(
                element,
                shopsSaleSupportData
            );
            let shopArchived = isValidation ? shopsArchived : [element.shopId];
            shopArchived.forEach((el: any) => {
                let objectData = {
                    userId: userID,
                    shopId: [el],
                    franchiseId: franchiseID,
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    data: {
                        [id]: {
                            id: id,
                            displayName: element[t("Display name")],
                            shopId: el,
                            support_de_vente: element[t("Sale support")],
                            tag: element.Tag,
                            isActive: el === "0" ? true : false,
                            isFavorite: element.isFavorite,
                            isArchived: false,
                            advancedDisplayName: element.advancedDisplayName,
                        },
                    },
                };

                localData.push(objectData);
            });
        });
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(localData),
        };
        try {
            const result = await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`,
                requestOptions
            );

            if (result.error) {
                throw new Error(result.message);
            }

            showSuccessToast(
                `${t("Sale support is successfully unarchived")!}`
            );
            setIsLoading(false);
            setKey(uuid());
        } catch (err) {
            ErrorToast(`${t("There's an error")!}`);
        }
    }

    return (
        <StyledModal toggle={true} isOpen={isModalConfirmationOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalConfirmationOpened(!isModalConfirmationOpened);
                    setDataIsUpdated!(true);
                }}
            >
                <StyledH2 className="text-uppercase">{t("Alert")}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "Attention! the sale support is archived at store level. Do you want to activate it in shops too?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        activeSaleSupport(false);
                        setIsModalConfirmationOpened(
                            !isModalConfirmationOpened
                        );
                        setDataIsUpdated!(true);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        activeSaleSupport(true);
                        setIsModalConfirmationOpened(
                            !isModalConfirmationOpened
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
